import { render, staticRenderFns } from "./summary-daily-sales.vue?vue&type=template&id=4504223f&scoped=true"
import script from "./summary-daily-sales.vue?vue&type=script&lang=ts"
export * from "./summary-daily-sales.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4504223f",
  null
  
)

export default component.exports